const footerLinks = [
  {
    title: "快速导航",
    items: [
      { href: "#entry", label: "免费版入口" },
      { href: "#features", label: "功能特点" },
      { href: "#comics", label: "热门漫画" },
      { href: "#compare", label: "版本对比" },
    ],
  },
  {
    title: "阅读支持",
    items: [
      { href: "#faq", label: "常见问题" },
      { href: "#top", label: "阅读帮助" },
      { href: "#comics", label: "漫画分类" },
      { href: "#top", label: "反馈建议" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 py-12 text-foreground-800 md:py-16">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-bug-line text-lg"></i>
              </span>
              <span className="font-heading text-xl">虫虫漫画</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              一个让每个人都能零门槛免费阅读漫画的平台。海量分类、每日奖励、
              清爽阅读体验，把追更变成一件快乐的小事。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-wechat-fill", "ri-qq-fill", "ri-weibo-fill", "ri-bilibili-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <nav key={group.title} aria-label={group.title}>
              <h3 className="text-sm font-bold">{group.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-600 sm:flex-row">
          <p>© {new Date().getFullYear()} 虫虫漫画 · 免费漫画阅读平台</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i>
            阅读愉快，理性消费，享受每一页故事
          </p>
        </div>
      </div>
    </footer>
  );
}